
export default function( settings )
{
    return {
        //settings можно смело модифицировать - он копируется для каждой игры из шаблона:
        settings,
        
        //name для удобства чтения логов на сервере:
        name : 'game_41',
        //идентификатор математики на сервере:
        id : 580,
        
        reactive,
        
        graphics : [
            
            //freegames:
            'res/games/freegames/finish.png',
            'res/games/freegames/start.png',
            'res/games/freegames/win_table_nums.xml',
            
            //small ticket:
            'res/games/small_ticket/balls_screen.png',
            'res/games/small_ticket/risk_screen00.png',
            'res/games/small_ticket/risk_screen01.png',
            'res/games/small_ticket/sat_01.png',
            'res/games/small_ticket/sat_02.png',
            'res/games/small_ticket/sat_03.png',
            'res/games/small_ticket/sat_04.png',
            'res/games/small_ticket/sat_05.png',
            'res/games/small_ticket/small_ticket_digits.xml',
            'res/games/small_ticket/miniballs/mb00.png',
            'res/games/small_ticket/miniballs/mb01.png',
            'res/games/small_ticket/miniballs/mb02.png',
            'res/games/small_ticket/miniballs/mb03.png',
            'res/games/small_ticket/miniballs/mb04.png',
            'res/games/small_ticket/miniballs/mb05.png',
            'res/games/small_ticket/miniballs/mb06.png',
            'res/games/small_ticket/miniballs/mb07.png',
            'res/games/small_ticket/miniballs/mb08.png',
            
            //help:
            'res/games/help/page_000.jpg',
            'res/games/help/page_001.jpg',
            'res/games/help/page_002.jpg',
            'res/games/help/page_003.jpg',
            'res/games/help/page_004.jpg',
            'res/games/help/page_005.jpg',
            'res/games/help/page_006.jpg',
            'res/games/help/page_007.jpg',
            'res/games/help/page_008.jpg',
            'res/games/help/page_009.jpg',
            'res/games/help/page_010.jpg',
            'res/games/help/page_011.jpg',
            'res/games/help/page_012.jpg',
            'res/games/help/page_013.jpg',
            'res/games/help/page_014.jpg',
            'res/games/help/page_015.jpg',
            'res/games/help/page_016.jpg',
            'res/games/help/page_017.jpg',
            'res/games/help/page_018.jpg',
            'res/games/help/page_019.jpg',
            'res/games/help/page_020.jpg',
            'res/games/help/page_021.jpg',
            'res/games/help/page_022.jpg',
            'res/games/help/page_023.jpg',
            'res/games/help/page_024.jpg',
            'res/games/help/page_025.jpg',
            'res/games/help/page_026.jpg',
            'res/games/help/page_027.jpg',
            'res/games/help/page_028.jpg',
            'res/games/help/page_029.jpg',
            'res/games/help/page_030.jpg',
            'res/games/help/page_031.jpg',
            'res/games/help/page_032.jpg',
            'res/games/help/page_033.jpg',
            
            //risk:
            'res/games/risk/masti/bubi.png',
            'res/games/risk/masti/piki.png',
            'res/games/risk/black_ball.png',
            'res/games/risk/blue_button.png',
            'res/games/risk/card_black.png',
            'res/games/risk/card_red.png',
            'res/games/risk/red_ball.png',
            'res/games/risk/red_button.png',
            'res/games/risk/risk_screen.png',
            'res/games/risk/rubaska_big/rbb.png',
            'res/games/risk/rubaska_big/rbr.png',
            'res/games/risk/risk_result_font.xml',
            'res/games/risk/risk_step_font.xml',
            'res/games/risk/risk_table.png',
            'res/games/risk/risk_table_light_part.png',
            'res/games/risk/risk_table_ball_red.png',
            'res/games/risk/risk_table_ball_black.png',
            'res/games/risk/risk_table_step_font.xml',
            'res/games/risk/risk_check.png',
            
            //table:
            'res/games/table/background.png',
            'res/games/table/coeff_tab_digits.xml',
            'res/games/table/comby00.png',
            'res/games/table/comby01.png',
            'res/games/table/comby02.png',
            'res/games/table/comby03.png',
            'res/games/table/comby04.png',
            //cheque:
            'res/games/cheque/chek.png',
            'res/games/cheque/digits_ishod.xml',
            'res/games/cheque/colours_circul/c00.png',
            'res/games/cheque/colours_circul/c01.png',
            'res/games/cheque/colours_circul/c02.png',
            'res/games/cheque/colours_circul/c03.png',
            'res/games/cheque/colours_circul/c04.png',
            'res/games/cheque/colours_circul/c05.png',
            'res/games/cheque/colours_circul/c06.png',
            'res/games/cheque/colours_circul/c07.png',
            'res/games/cheque/colours_circul/c08.png',
            'res/games/table/rc00.png',
            'res/games/table/rc01.png',
            'res/games/table/rc02.png',
            'res/games/table/rc03.png',
            'res/games/table/rc04.png',
            'res/games/table/rc05.png',
            'res/games/table/rc06.png',
            'res/games/table/rc07.png',
            'res/games/table/rc08.png',
            
            //ui:
            'res/games/ui/yello_dig.xml',
            'res/games/ui/auto_of.png',
            'res/games/ui/auto_on.png',
            'res/games/ui/black_of.png',
            'res/games/ui/black_on.png',
            'res/games/ui/exit_pari_of.png',
            'res/games/ui/exit_pari_on.png',
            'res/games/ui/menu_of.png',
            'res/games/ui/menu_on.png',
            'res/games/ui/red_of.png',
            'res/games/ui/red_on.png',
            'res/games/ui/rezultat_of.png',
            'res/games/ui/rezultat_on.png',
            'res/games/ui/size_step_on.png',
            'res/games/ui/size_step_of.png',
            'res/games/ui/visual_mode_of.png',
            'res/games/ui/visual_mode_on.png',

            'res/games/ui/help_back_on.png',
            'res/games/ui/help_back_off.png',
            'res/games/ui/help_bell_on.png',
            'res/games/ui/help_bell_off.png',
            'res/games/ui/help_next_on.png',
            'res/games/ui/help_next_off.png',
            'res/games/ui/help_prev_on.png',
            'res/games/ui/help_prev_off.png',
            'res/games/ui/info_on.png',
            'res/games/ui/info_off.png',

            'res/games/ui/free_result.png',
            
            'res/games/screen.png',
            'res/games/under_screen.png',
            'res/games/game_text.png',
            'res/games/risk_text.png',
            
            'res/games/billets/pl00.png',
            'res/games/billets/pl01.png',
            'res/games/billets/pl02.png',
            'res/games/billets/pl03.png',
            'res/games/billets/pl04.png',
            'res/games/billets/pl05.png',
            'res/games/billets/pl06.png',
            'res/games/billets/pl07.png',
            'res/games/billets/pl08.png',
            
            'res/games/frames/c00.png',
            'res/games/frames/c01.png',
            'res/games/frames/c02.png',
            'res/games/frames/c03.png',
            'res/games/frames/c04.png',
            'res/games/frames/c05.png',
            'res/games/frames/c06.png',
            'res/games/frames/c07.png',
            'res/games/frames/c08.png',
            
            'res/games/lines/line_00.png',
            'res/games/lines/line_01.png',
            'res/games/lines/line_02.png',
            'res/games/lines/line_03.png',
            'res/games/lines/line_04.png',
            'res/games/lines/line_05.png',
            'res/games/lines/line_06.png',
            'res/games/lines/line_07.png',
            'res/games/lines/line_08.png',
            
            'res/games/mini_balls/for_balls.png',
            'res/games/a1_a15.png',
            //потом займёмся упаковкой и прочим ;) (думаю даже вообще удастся как-то свести все эти игры под одну с маленькими отличиями) ...
            'res/games/mini_balls/0_00.png',
            'res/games/mini_balls/0_01.png',
            'res/games/mini_balls/0_02.png',
            'res/games/mini_balls/1_00.png',
            'res/games/mini_balls/1_01.png',
            'res/games/mini_balls/1_02.png',
            'res/games/mini_balls/2_00.png',
            'res/games/mini_balls/2_01.png',
            'res/games/mini_balls/2_02.png',
            'res/games/mini_balls/3_00.png',
            'res/games/mini_balls/3_01.png',
            'res/games/mini_balls/3_02.png',
            'res/games/mini_balls/4_00.png',
            'res/games/mini_balls/4_01.png',
            'res/games/mini_balls/4_02.png',
            'res/games/mini_balls/5_00.png',
            'res/games/mini_balls/5_01.png',
            'res/games/mini_balls/5_02.png',
            'res/games/mini_balls/6_00.png',
            'res/games/mini_balls/6_01.png',
            'res/games/mini_balls/6_02.png',
            'res/games/mini_balls/7_00.png',
            'res/games/mini_balls/7_01.png',
            'res/games/mini_balls/7_02.png',
            'res/games/mini_balls/8_00.png',
            'res/games/mini_balls/8_01.png',
            'res/games/mini_balls/8_02.png',
            'res/games/mini_balls/9_00.png',
            'res/games/mini_balls/9_01.png',
            'res/games/mini_balls/9_02.png',
            'res/games/mini_balls/10_00.png',
            'res/games/mini_balls/10_01.png',
            'res/games/mini_balls/10_02.png',
            'res/games/mini_balls/11_00.png',
            'res/games/mini_balls/11_01.png',
            'res/games/mini_balls/11_02.png',
            'res/games/mini_balls/12_00.png',
            'res/games/mini_balls/12_01.png',
            'res/games/mini_balls/12_02.png',
            'res/games/mini_balls/black_01.png',
            'res/games/mini_balls/red_01.png',
            
            'res/games/balls/0/0_000.png',
            'res/games/balls/0/0_001.png',
            'res/games/balls/0/0_002.png',
            'res/games/balls/0/0_003.png',
            'res/games/balls/0/0_004.png',
            'res/games/balls/0/0_005.png',
            'res/games/balls/0/0_006.png',
            'res/games/balls/0/0_007.png',
            'res/games/balls/0/0_008.png',
            'res/games/balls/1/1_000.png',
            'res/games/balls/1/1_001.png',
            'res/games/balls/1/1_002.png',
            'res/games/balls/1/1_003.png',
            'res/games/balls/1/1_004.png',
            'res/games/balls/1/1_005.png',
            'res/games/balls/1/1_006.png',
            'res/games/balls/1/1_007.png',
            'res/games/balls/1/1_008.png',
            'res/games/balls/2/2_000.png',
            'res/games/balls/2/2_001.png',
            'res/games/balls/2/2_002.png',
            'res/games/balls/2/2_003.png',
            'res/games/balls/2/2_004.png',
            'res/games/balls/2/2_005.png',
            'res/games/balls/2/2_006.png',
            'res/games/balls/2/2_007.png',
            'res/games/balls/2/2_008.png',
            'res/games/balls/3/3_000.png',
            'res/games/balls/3/3_001.png',
            'res/games/balls/3/3_002.png',
            'res/games/balls/3/3_003.png',
            'res/games/balls/3/3_004.png',
            'res/games/balls/3/3_005.png',
            'res/games/balls/3/3_006.png',
            'res/games/balls/3/3_007.png',
            'res/games/balls/3/3_008.png',
            'res/games/balls/4/4_000.png',
            'res/games/balls/4/4_001.png',
            'res/games/balls/4/4_002.png',
            'res/games/balls/4/4_003.png',
            'res/games/balls/4/4_004.png',
            'res/games/balls/4/4_005.png',
            'res/games/balls/4/4_006.png',
            'res/games/balls/4/4_007.png',
            'res/games/balls/4/4_008.png',
            'res/games/balls/5/5_000.png',
            'res/games/balls/5/5_001.png',
            'res/games/balls/5/5_002.png',
            'res/games/balls/5/5_003.png',
            'res/games/balls/5/5_004.png',
            'res/games/balls/5/5_005.png',
            'res/games/balls/5/5_006.png',
            'res/games/balls/5/5_007.png',
            'res/games/balls/5/5_008.png',
            'res/games/balls/6/6_000.png',
            'res/games/balls/6/6_001.png',
            'res/games/balls/6/6_002.png',
            'res/games/balls/6/6_003.png',
            'res/games/balls/6/6_004.png',
            'res/games/balls/6/6_005.png',
            'res/games/balls/6/6_006.png',
            'res/games/balls/6/6_007.png',
            'res/games/balls/6/6_008.png',
            'res/games/balls/7/7_000.png',
            'res/games/balls/7/7_001.png',
            'res/games/balls/7/7_002.png',
            'res/games/balls/7/7_003.png',
            'res/games/balls/7/7_004.png',
            'res/games/balls/7/7_005.png',
            'res/games/balls/7/7_006.png',
            'res/games/balls/7/7_007.png',
            'res/games/balls/7/7_008.png',
            'res/games/balls/8/8_000.png',
            'res/games/balls/8/8_001.png',
            'res/games/balls/8/8_002.png',
            'res/games/balls/8/8_003.png',
            'res/games/balls/8/8_004.png',
            'res/games/balls/8/8_005.png',
            'res/games/balls/8/8_006.png',
            'res/games/balls/8/8_007.png',
            'res/games/balls/8/8_008.png',
            'res/games/balls/9/9_000.png',
            'res/games/balls/9/9_001.png',
            'res/games/balls/9/9_002.png',
            'res/games/balls/9/9_003.png',
            'res/games/balls/9/9_004.png',
            'res/games/balls/9/9_005.png',
            'res/games/balls/9/9_006.png',
            'res/games/balls/9/9_007.png',
            'res/games/balls/9/9_008.png',
            'res/games/balls/10/10_000.png',
            'res/games/balls/10/10_001.png',
            'res/games/balls/10/10_002.png',
            'res/games/balls/10/10_003.png',
            'res/games/balls/10/10_004.png',
            'res/games/balls/10/10_005.png',
            'res/games/balls/10/10_006.png',
            'res/games/balls/10/10_007.png',
            'res/games/balls/10/10_008.png',
            'res/games/balls/11/11_000.png',
            'res/games/balls/11/11_001.png',
            'res/games/balls/11/11_002.png',
            'res/games/balls/11/11_003.png',
            'res/games/balls/11/11_004.png',
            'res/games/balls/11/11_005.png',
            'res/games/balls/11/11_006.png',
            'res/games/balls/11/11_007.png',
            'res/games/balls/11/11_008.png',
            'res/games/balls/12/12_000.png',
            'res/games/balls/12/12_001.png',
            'res/games/balls/12/12_002.png',
            'res/games/balls/12/12_003.png',
            'res/games/balls/12/12_004.png',
            'res/games/balls/12/12_005.png',
            'res/games/balls/12/12_006.png',
            'res/games/balls/12/12_007.png',
            'res/games/balls/12/12_008.png',
            
            //common:
            'res/games/preloader.png',
        ],
        sounds : [
            'res/games/sounds/ball_end_roll',
            'res/games/sounds/balls_away',
            'res/games/sounds/balls_roll_music',
            'res/games/sounds/help_paging',
            'res/games/sounds/lines_0',
            'res/games/sounds/lines_1',
            'res/games/sounds/lines_2',
            'res/games/sounds/lines_3',
            'res/games/sounds/lines_4',
            'res/games/sounds/risk_lose',
            'res/games/sounds/risk_win',
            'res/games/sounds/card_blink',
            'res/games/sounds/game_41_win_sound_0',
            'res/games/sounds/game_41_win_sound_1',
            'res/games/sounds/game_41_win_sound_2',
            'res/games/sounds/game_41_win_sound_3',
        ],
    }
}

function reactive( { space, container } ) {
    //тут можно изменять space типа space.s( 'stream' ).alter() или добавлять что-то в container ...

    const win_sounds = [];
    for (let i = 0; i < 4; ++i) {
        win_sounds.push(sounds.get('res/games/sounds/game_41_win_sound_' + i));
    }

    const getWinSound = (line, math) =>  {
        const winPosition = math.lineWinPositions(line);

        if (!winPosition) return null;

        let winSymbolsCount = 0;
        let hasWild = false;
        for (let i = 0; i < winPosition.length; ++i) {
            if (winPosition[i] !== null && winPosition[i] !== undefined) {
                if (math.slotSymbols()[winPosition[i]] === math.wild) {
                    hasWild = true;
                }
                winSymbolsCount++;
            }
        }

        switch (winSymbolsCount) {
            case 5:
                return win_sounds[3];
            case 4:
                return win_sounds[2];
            case 3:
                return win_sounds[1];
            case 2:
                if (hasWild) {
                    return win_sounds[1];
                }
                return win_sounds[0];
        }

        return null;
    };

    space.s( 'presenter:play_line' )
        .with(space.s('presenter:show_first_time'), (line_order, atFirst) => {
            if (atFirst && line_order >= 0) {
                return line_order
            }
            else {
                return -1
            }
        })
        .filter(line_order => line_order >= 0)
        .with(space.s('math'), (line, math) => ({line, math}))
        .on(({line, math}) => {
            let lineNumber = math.winLines()[line];
            let snd = getWinSound(lineNumber, math);
            if (snd) {
                snd.play();
            }
        });

    space.s( 'presenter:play_scatters' )
        .with(space.s('presenter:show_first_time'), (scatter, atFirst) => scatter && atFirst)
        .filter(play => play)
        .with(space.s('math'), (_, math) => math)
        .on(math => {
            if (math.scatterWin() > 0) {
                const scatterCount = math.scatterCount();
                win_sounds[scatterCount - 2].play();
            }
        })
}






// WEBPACK FOOTER //
// ./src/games/game_41.es6